import React from "react";

import Top from './images/icons/up.png'
import Egypt from './images/icons/egypt.png'
import Dark from './images/icons/moon.png'
import lantern from './images/elements/Contact Us/Design.png'
import Twitter from './images/icons/Social/twitter.png'
import YouTube from './images/icons/Social/youtube.png'
import Facebook from './images/icons/Social/facebook.png'
import Instagram from './images/icons/Social/instagram.png'
import Mosque from './images/elements/Contact Us/Mosque.png'

const Contact = () => (
  <div className="contactpage">
    <section className="Top">
      <img className="ph1" src={lantern} alt="" />
      <div className="head">
        <div className="title">
          <h1 id="tc1">
            Register to <br />
            our<span> Newsletter!</span>
          </h1>
        </div>
        <form action="/submitemail.php" target="_blank" method="get" autoComplete="on">
          <div>
            <input type="text" placeholder="First Name*" id="fname" name="fname" required />
          </div>
          <br />
          <div>
            <input type="text" placeholder="Last Name*" id="lname" name="lname" required />
          </div>
          <br />
          <div>
            <input type="email" id="email" name="email" placeholder="Email Subject*" required />
          </div>
          <br />
          <div>
            <textarea name="txtarea" id="txtarea" cols="30" rows="6" placeholder="Write something here..."></textarea>
          </div>
          <br />
          <div>
            <input type="submit" id="pc1" value="SUBMIT EMAIL" className="submit" />
          </div>
        </form>
      </div>
    </section>
    {/* Footer */}
    <footer>
      <div className="content">
        <div className="heading">
          <img src={Mosque} alt="" />
          <h1>Dhul Hijjah</h1>
        </div>
        <div className="paragraph">
          <h4>
            <b>Quick Links</b>
          </h4>
        </div>
        <div className="navs">
          <ul>
            <li>
              <a href="/index.html">Home</a>
            </li>
            <li>
              <a href="/index.html">What is it?</a>
            </li>
            <li>
              <a href="/pages/event.html">Articles</a>
            </li>
          </ul>

          <ul className="col1">
            <li>
              <a href="/pages/about.html">About</a>
            </li>
            <li>
              <a href="/pages/index.html">Its Importance</a>
            </li>
            <li>
              <a href="/pages/about.html">The Team</a>
            </li>
          </ul>

          <ul className="col2">
            <li>
              <a href="/pages/event.html">Events</a>
            </li>
            <li>
              <a href="/pages/locations.html">The Ten Days</a>
            </li>
            <li>
              <a href="/pages/event.html">Blog</a>
            </li>
          </ul>
          <ul className="col3">
            <li>
              <a href="/pages/locations.html">Locations</a>
            </li>
            <li>
              <a href="/pages/event.html">Tips</a>
            </li>
            <li>
              <a href="/pages/contact.html">Contact Us</a>
            </li>
          </ul>
        </div>
        <div className="icons">
          <img src={Twitter} alt="Twitter" />
          <img src={YouTube} alt="YouTube" />
          <img src={Facebook} alt="Facebook" />
          <img src={Instagram} alt="Instagram" />
          <p>2021-2022 Dhul Hijjah. All Rights Reserved.</p>
        </div>
      </div>
    </footer>

    <div className="features">
    <a href="#"> <img src={Top} width="40" style={{ border: 'none' }} id="toTop" className="test"/></a>
    <a href="#"> <img src={Egypt} width="40"/></a>
    <a href="#"> <img src={Dark} width="40"/></a>
    </div>

  </div>
);

export default Contact;
